import React, { Suspense, lazy } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import FilterSettings from "../pages/app/Inbound/components/Settings/ImportSettings/FilterSettings";
import { CircularProgress } from "@mui/material";
import { StudentListing, DemoTaskDetailsPage, Fees } from "../pages/index";
import { ImportPreview } from "../pages/index";
import ManageInboundRoot from "../pages/app/Inbound/components/ManageInbound/ManageInboundRoot";
import ManageSettingsRoot from "../pages/app/Settings/components/ManageSettings/ManageSettingsRoot";
import ManageIntegrationRouter from "./ManageIntegrationRouter";
import ManageInboundSettingsRoot from "../pages/app/Inbound/components/ManageInbound/ManageInboundSettingsRoot";
import getAccessStatus, {
  checkAccess,
  getSubDomainAccessStatus,
} from "../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";
import NoAccess from "../components/NoAccess/NoAccess";
import ReportRoot from "../pages/app/Reports/ReportRoot/ReportRoot";
import RevenueReportCreation from "../pages/app/Reports/components/ReportCreation/RevenueReportCreation";
import DetailedAttendancePage from "../pages/app/Reports/components/ReportCreation/DetailedAttendancePage";
import TransactionsReportCreation from "../pages/app/Reports/components/ReportCreation/TransactionsReportCreation";

const Dashboard = lazy(() =>
  import("../pages").then((module) => ({ default: module.Dashboard }))
);
const Home = lazy(() =>
  import("../pages").then((module) => ({ default: module.Home }))
);
const NotFound = lazy(() =>
  import("../pages").then((module) => ({ default: module.NotFound }))
);

const Nurture = lazy(() =>
  import("../pages").then((module) => ({ default: module.Nurture }))
);
const ManageRoot = lazy(() =>
  import("../pages").then((module) => ({ default: module.ManageRoot }))
);
const Tasks = lazy(() =>
  import("../pages").then((module) => ({ default: module.Tasks }))
);
const EmailDetails = lazy(() =>
  import("../pages").then((module) => ({ default: module.EmailDetails }))
);
const CompletedTasks = lazy(() =>
  import("../pages").then((module) => ({ default: module.CompletedTasks }))
);

const EmailSyncing = lazy(() =>
  import("../pages").then((module) => ({ default: module.EmailSyncing }))
);

const Integrations = lazy(() =>
  import("../pages").then((module) => ({ default: module.Integrations }))
);
// const Reports =lazy(() =>
//   import("../pages").then((module) => ({ default: module.RecentReports }))
// );

const Attendance = lazy(() =>
  import("../pages").then((module) => ({ default: module.Attendance }))
);

const AttendanceDetails = lazy(() =>
  import("../pages").then((module) => ({ default: module.AttendanceDetails }))
);

const LeadReportCreation = lazy(() =>
  import("../pages").then((module) => ({ default: module.LeadReportCreation }))
);

const AttendanceReportCreation = lazy(() =>
  import("../pages").then((module) => ({
    default: module.AttendanceReportCreation,
  }))
);

export default function AppRouter(props: any) {
  const { handleCompress } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const accountStatus = instituteData?.billingStatus;
  const profileCompletedStatus = instituteData?.isProfileCompleted;
  const batchCreated = instituteData?.batchCreated;
  const courseCreated = instituteData?.courseCreated;
  const branchCreated = instituteData?.branchCreated;
  const teamCreated = instituteData?.teamAdded;
  const profileDetailsCompleted = instituteData?.profileDetailsCompleted;

  const { userById } = useSelector((state: any) => state.userDetails);
  const inboundAccess = checkAccess("INBOUND", userById?.rolePermission);
  const nurtureAccess = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "BOARD",
    "BOARD_ACCESS",
    userById?.rolePermission
  );
  const studentsAccess = checkAccess("STUDENTS", userById?.rolePermission);
  const integrationsAccess = checkAccess(
    "INTEGRATIONS",
    userById?.rolePermission
  );
  const reportAccess = checkAccess("REPORT", userById?.rolePermission);
  const settingsAccess = checkAccess("SETTINGS", userById?.rolePermission);
  const reportAllAccess = getAccessStatus(
    "REPORT",
    "ALL_ACCESS",
    userById?.rolePermission
  );
  const attendancesAccess = checkAccess("ATTENDANCE", userById?.rolePermission);

  const shouldDisableGeneralSetup =
    accountStatus === "ARCHIVED" ||
    accountStatus === "LOCKED" ||
    accountStatus === "UNARCHIVED" ||
    accountStatus === "INACTIVE";

  if (profileCompletedStatus) {
    if (
      (location.pathname.includes("Inbound") ||
        location.pathname.includes("Nurture") ||
        location.pathname.includes("Tasks") ||
        location.pathname.includes("Students") ||
        location.pathname.includes("Attendance") ||
        location.pathname.includes("Integrations") ||
        location.pathname.includes("Settings")) &&
      shouldDisableGeneralSetup
    ) {
      navigate("/app/dashboard");
      return null;
    }
  } else if (!profileCompletedStatus) {
    if (
      location.pathname.includes("Inbound") ||
      location.pathname.includes("Nurture") ||
      location.pathname.includes("Tasks") ||
      location.pathname.includes("Students") ||
      location.pathname.includes("Attendance") ||
      location.pathname.includes("Integrations") ||
      location.pathname.includes("Settings")
    ) {
      navigate("/app/home");
      return null;
    }
  }

  // if (
  //   instituteData &&
  //   !location.pathname.includes("/app/home") &&
  //   !profileCompletedStatus
  // ) {
  //   if (
  //     !courseCreated &&
  //     !batchCreated &&
  //     !branchCreated &&
  //     !teamCreated &&
  //     !profileDetailsCompleted
  //   ) {
  //     navigate("/app/manage/InstituteProfile/:id");
  //     return null;
  //   }

  //   if (
  //     !location.pathname.includes("createBranch") &&
  //     !courseCreated &&
  //     !batchCreated &&
  //     !branchCreated &&
  //     !teamCreated &&
  //     profileDetailsCompleted
  //   ) {
  //     navigate("/app/manage/createBranch");
  //     return null;
  //   }

  //   if (
  //     !location.pathname.includes("createCourse") &&
  //     !courseCreated &&
  //     !batchCreated &&
  //     branchCreated &&
  //     !teamCreated &&
  //     profileDetailsCompleted
  //   ) {
  //     navigate("/app/manage/createCourse");
  //     return null;
  //   }

  //   if (
  //     !location.pathname.includes("createTeam") &&
  //     courseCreated &&
  //     !batchCreated &&
  //     branchCreated &&
  //     !teamCreated &&
  //     profileDetailsCompleted
  //   ) {
  //     navigate("/app/manage/createTeam");
  //     return null;
  //   }

  //   if (
  //     !location.pathname.includes("createBatch") &&
  //     courseCreated &&
  //     !batchCreated &&
  //     branchCreated &&
  //     teamCreated &&
  //     profileDetailsCompleted
  //   ) {
  //     navigate("/app/manage/createBatch");
  //     return null;
  //   }
  // }

  return (
    <Routes>
      <Route
        path="/manage/*"
        element={
          <Suspense fallback={<CircularProgress />}>
            <ManageRoot />
          </Suspense>
        }
      />
      <Route
        path="/home"
        element={
          <Suspense fallback={<CircularProgress />}>
            <Home />
          </Suspense>
        }
      />
      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<CircularProgress />}>
            <Dashboard />
          </Suspense>
        }
      />

      <Route
        path="*"
        element={
          <Suspense fallback={<CircularProgress />}>
            <NotFound />
          </Suspense>
        }
      />
      <Route
        path="/inbound/*"
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <ManageInboundRoot />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />

      <Route
        path={"/Inbound/Email/EmailDetail/:id"}
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <EmailDetails />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />

      <Route
        path="/Inbound/ImportPreview"
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <ImportPreview />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Inbound/EmailIntegration/EmailSyncing"
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <EmailSyncing />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Inbound/Settings/*"
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <ManageInboundSettingsRoot />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />

      <Route
        path="/Inbound/Settings/Import/filter"
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <FilterSettings />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Inbound/Settings/ImportSetting/filter"
        element={
          inboundAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <FilterSettings />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Nurture"
        element={
          nurtureAccess ? (
            <Nurture handleCompress={handleCompress} />
          ) : (
            <NoAccess />
          )
        }
      />

      <Route
        path="/Tasks"
        element={
          <Suspense fallback={<CircularProgress />}>
            <Tasks />
          </Suspense>
        }
      />
      <Route
        path="/Tasks/TaskCompleted"
        element={
          <Suspense fallback={<CircularProgress />}>
            <CompletedTasks />
          </Suspense>
        }
      />
      <Route
        path="/Tasks/DemoTaskDetails/:id"
        element={
          <Suspense fallback={<CircularProgress />}>
            <DemoTaskDetailsPage />
          </Suspense>
        }
      />

      <Route
        path="/Students"
        element={
          studentsAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <StudentListing />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />

      <Route
        path="/Integrations/*"
        element={
          integrationsAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <ManageIntegrationRouter />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Integrations"
        element={
          integrationsAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <Integrations />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />

      <Route
        path="/Reports/*"
        element={
          reportAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <ReportRoot />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Reports/LeadReportCreation"}
        element={
          reportAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <LeadReportCreation />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Reports/CreateReport/Revenue"}
        element={
          reportAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <RevenueReportCreation add={true} />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Reports/Revenue/:id"}
        element={
          reportAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <RevenueReportCreation add={false} />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Reports/AttendanceReportCreation"}
        element={
          reportAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <AttendanceReportCreation />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Reports/AttendanceReportCreation/DetailedAttendancePage"}
        element={
          reportAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <DetailedAttendancePage />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Settings/*"
        element={
          settingsAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <ManageSettingsRoot />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path="/Attendance/*"
        element={
          attendancesAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <Attendance />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Attendance/:id"}
        element={
          attendancesAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <AttendanceDetails />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/Reports/CreateReport/Transaction"}
        element={
          <Suspense fallback={<CircularProgress />}>
            <TransactionsReportCreation add={true} />
          </Suspense>
        }
      />
      <Route
        path={"/Reports/Transaction/:id"}
        element={
          <Suspense fallback={<CircularProgress />}>
            <TransactionsReportCreation add={false} />
          </Suspense>
        }
      />
      <Route
        path="/Transactions"
        element={
          studentsAccess ? (
            <Suspense fallback={<CircularProgress />}>
              <Fees />
            </Suspense>
          ) : (
            <NoAccess />
          )
        }
      />
    </Routes>
  );
}
